import React from 'react';
import Icon from '../../../components/AppIcon';

const DependentUserCard = ({ profile, onViewDetails }) => {
  const getRelationshipIcon = (relationship) => {
    const icons = {
      parent: 'Users',
      child: 'Baby',
      spouse: '/assets/images/MyBodyToday_logo_design2-removebg-preview1-1770673381636.png',
      sibling: 'Users',
      caregiver: 'UserCheck',
      self: 'User',
      other: 'User'
    };
    return icons?.[relationship] || 'User';
  };

  const getAgeDisplay = (age, dateOfBirth) => {
    if (age) return `${age} years old`;
    if (dateOfBirth) {
      const birthDate = new Date(dateOfBirth);
      const today = new Date();
      const calculatedAge = today?.getFullYear() - birthDate?.getFullYear();
      return `${calculatedAge} years old`;
    }
    return 'Age not specified';
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-4 sm:p-6 transition-smooth hover:shadow-therapeutic-md">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary/10 flex items-center justify-center">
          {profile?.avatarUrl ? (
            <img 
              src={profile?.avatarUrl} 
              alt={`${profile?.name} avatar`}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <Icon 
              name={getRelationshipIcon(profile?.relationship)} 
              size={28} 
              className="text-primary"
              strokeWidth={2}
            />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div>
              <h3 className="text-lg sm:text-xl font-heading font-semibold text-foreground line-clamp-1">
                {profile?.name}
              </h3>
              <p className="text-sm text-muted-foreground capitalize">
                {profile?.relationship?.replace('_', ' ')}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 mb-3">
            <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium bg-muted text-muted-foreground">
              <Icon name="Calendar" size={12} strokeWidth={2} />
              {getAgeDisplay(profile?.age, profile?.dateOfBirth)}
            </span>
            {profile?.gender && (
              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium bg-muted text-muted-foreground capitalize">
                <Icon name="User" size={12} strokeWidth={2} />
                {profile?.gender?.replace('_', ' ')}
              </span>
            )}
            {profile?.bloodGroup && (
              <span className="inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium bg-error/10 text-error">
                <Icon name="Droplet" size={12} strokeWidth={2} />
                {profile?.bloodGroup?.toUpperCase()?.replace('-', ' ')}
              </span>
            )}
          </div>

          <div className="flex gap-2">
            <button
              onClick={onViewDetails}
              className="flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg text-sm font-medium transition-smooth hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background active:scale-[0.97]"
            >
              <Icon name="Eye" size={16} strokeWidth={2} />
              View Details
            </button>
            <button
              onClick={() => window.location.href = `/daily-check-in?dependent=${profile?.id}`}
              className="flex items-center gap-2 px-4 py-2 bg-accent text-accent-foreground rounded-lg text-sm font-medium transition-smooth hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background active:scale-[0.97]"
            >
              <Icon name="Plus" size={16} strokeWidth={2} />
              Quick Log
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DependentUserCard;